import React from 'react';
import WarmupConsole from '../../../../components/Warmups/WarmupConsole';
import './ConductingStrip.css';

/**
 * The conducting strip — I1's answer to "the key was the smallest thing on the
 * screen."
 *
 * A sticky band under the lesson bar carrying the readout and every transport
 * control, at desktop widths, on the Warm-ups tab only. It is the SAME markup
 * WarmupConsole renders everywhere else (phase 0 split it out for exactly this);
 * only the layout and the type scale change, in ConductingStrip.css.
 *
 * WHY A BAND AND NOT A COLUMN. The teacher is at a piano, often standing, often
 * across the room from the screen. I1's bet is that the two things she glances
 * at — which key we are in and how high we are going — belong in a fixed place
 * that does not move when she switches between a song tab and Warm-ups. So the
 * rail, the notes column and the jot bar are untouched by this component; the
 * only thing that changes shape between modes is the right track.
 *
 * The page decides whether to render it (see LessonDashboard/index.js): desktop
 * width, Warm-ups tab, and a routine actually loaded. This component does not
 * guard — LessonWarmups owns the loading/empty states, and a strip that renders
 * a spinner across the top of the lesson would be worse than no strip.
 */
const ConductingStrip = ({ wp }) => (
	<div className="ld-strip" role="region" aria-label="Warm-up transport">
		<WarmupConsole wp={wp} keyLabel="Warm-up key" />
	</div>
);

export default ConductingStrip;
